import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  ContactForm,
  ProfileForm,
  SchoolForm,
  Pupil,
  CoursesForm,
} from '@lyceo/homi/pupils/util-models';
import { PersonProfileDto } from './pupil.dto';

export const PupilDetailsMenuBarActions = createActionGroup({
  source: 'Pupil Details Menu Bar',
  events: {
    Init: emptyProps(),
  },
});

export const PupilInformationPageActions = createActionGroup({
  source: 'Pupil Information Page',
  events: {
    Init: emptyProps(),
  },
});

export const PupilDetailsInformationActions = createActionGroup({
  source: 'Pupil Details Information',
  events: {
    'Edit Profile Clicked': emptyProps(),
    'Edit Contact Clicked': emptyProps(),
    'Edit School Clicked': emptyProps(),
    'Edit Courses Clicked': emptyProps(),
  },
});

export const PupilProfileDialogActions = createActionGroup({
  source: 'Pupil Profile Dialog',
  events: {
    'Submit Profile': props<{ profile: ProfileForm }>(),
    'Closed': emptyProps(),
  },
});

export const PupilContactDialogActions = createActionGroup({
  source: 'Pupil Contact Dialog',
  events: {
    'Edit Contact': props<{ contact: ContactForm }>(),
    'Closed': emptyProps(),
  },
});

export const PupilSchoolDialogActions = createActionGroup({
  source: 'Pupil School Dialog',
  events: {
    'Edit School': props<{ school: SchoolForm }>(),
    'Closed': emptyProps(),
  },
});

export const PupilCoursesDialogActions = createActionGroup({
  source: 'Pupil Courses Dialog',
  events: {
    'Submit Courses': props<{ courses: CoursesForm }>(),
    'Closed': emptyProps(),
  },
});

export const PupilAPIActions = createActionGroup({
  source: 'Pupils API',
  events: {
    'Get Pupil Profile By Id': emptyProps(),
    'Get Pupil Profile By Id Success': props<{
      pupilProfile: PersonProfileDto;
    }>(),
    'Get Pupil Profile By Id Failure': props<{ error: Error }>(),
    'Patch Pupil Profile Success': props<{ pupil: Pupil }>(),
    'Patch Pupil Profile Failure': props<{ error: Error }>(),
    'Update Pupil Courses Success': props<{
      pupilId: string;
      courseIds: string[];
    }>(),
    'Update Pupil Courses Failure': props<{ error: Error }>(),
  },
});
